import * as fromDatatype from "../datatype-library";

export interface bl_fi_cashbook_imported_file_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    namespace : fromDatatype.TextDatatypeInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid:fromDatatype.GuidDataFieldInterface;
    name: fromDatatype.TextDatatypeInterface;
    descr: fromDatatype.TextDatatypeInterface;
    ccy_code: fromDatatype.VarcharDatatypeInterface;
    guid_comp:fromDatatype.GuidDataFieldInterface;
    // gen_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
    // gen_doc_line_guid: fromDatatype.GuidDataFieldInterface;
    guid_cashbook: fromDatatype.GuidDataFieldInterface;
    reference_num_1: fromDatatype.VarcharDatatypeInterface;
    reference_num_2: fromDatatype.VarcharDatatypeInterface;
    date_txn_doc: fromDatatype.TimestampTzDatatypeInterface;
    date_posting: fromDatatype.TimestampTzDatatypeInterface;
    amt_debit: fromDatatype.NumericDatatypeInterface;
    amt_credit: fromDatatype.NumericDatatypeInterface;
    ds_pk:fromDatatype.VarcharDatatypeInterface;
    ds_type:fromDatatype.VarcharDatatypeInterface;
    ds_code:fromDatatype.VarcharDatatypeInterface;
    ds_url:fromDatatype.VarcharDatatypeInterface;
    ds_property_json:fromDatatype.JsonDatatypeInterface;
    obj_type: fromDatatype.VarcharDatatypeInterface;
    obj_code: fromDatatype.VarcharDatatypeInterface;
    obj_option: fromDatatype.VarcharDatatypeInterface;
    property_json:fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
    updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
    acl_policy:fromDatatype.JsonDatatypeInterface;
    acl_config:fromDatatype.JsonDatatypeInterface;
}

export class bl_fi_cashbook_imported_file_hdr_RowClass implements bl_fi_cashbook_imported_file_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    namespace : fromDatatype.TextDatatypeInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid:fromDatatype.GuidDataFieldInterface;
    name: fromDatatype.TextDatatypeInterface;
    descr: fromDatatype.TextDatatypeInterface;
    ccy_code: fromDatatype.VarcharDatatypeInterface;
    guid_comp:fromDatatype.GuidDataFieldInterface;
    // gen_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
    // gen_doc_line_guid: fromDatatype.GuidDataFieldInterface;
    guid_cashbook: fromDatatype.GuidDataFieldInterface;
    reference_num_1: fromDatatype.VarcharDatatypeInterface;
    reference_num_2: fromDatatype.VarcharDatatypeInterface;
    date_txn_doc: fromDatatype.TimestampTzDatatypeInterface;
    date_posting: fromDatatype.TimestampTzDatatypeInterface;
    amt_debit: fromDatatype.NumericDatatypeInterface;
    amt_credit: fromDatatype.NumericDatatypeInterface;
    ds_pk:fromDatatype.VarcharDatatypeInterface;
    ds_type:fromDatatype.VarcharDatatypeInterface;
    ds_code:fromDatatype.VarcharDatatypeInterface;
    ds_url:fromDatatype.VarcharDatatypeInterface;
    ds_property_json:fromDatatype.JsonDatatypeInterface;
    obj_type: fromDatatype.VarcharDatatypeInterface;
    obj_code: fromDatatype.VarcharDatatypeInterface;
    obj_option: fromDatatype.VarcharDatatypeInterface;
    property_json:fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
    updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
    acl_policy:fromDatatype.JsonDatatypeInterface;
    acl_config:fromDatatype.JsonDatatypeInterface;
}